import TripTravellerAllocationFlightModule from './trip-traveller-allocation-flight/trip-traveller-allocation-flight-module';

import TripTravellerAllocationSegment from './trip-traveller-allocation-segment-component';
import TripTravellerAllocationSegmentService from './trip-traveller-allocation-segment-service';

import './trip-traveller-allocation-segment.scss';

const MODULE_NAME = 'app.trip.traveller-allocation.segment';
const module = angular.module(MODULE_NAME, [
        TripTravellerAllocationFlightModule,
    ])
    .directive(TripTravellerAllocationSegment.DIRECTIVE_NAME, TripTravellerAllocationSegment)
    .service('tripTravellerAllocationSegmentService', TripTravellerAllocationSegmentService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/checkout/trip-traveller-allocation/trip-traveller-allocation-segment/trip-traveller-allocation-segment-module.js